import { GetExclusiveId } from "../../../flowchart/utils/tools";
import Mapping from "./Mapping"

class LossStructure {
  constructor(mi = [], mo = new Mapping){
    this.id = mo.parentId ? mo.parentId : GetExclusiveId();
    mi.forEach(m => {
      m.parentId = this.id
      m.setValue()
    })
    mo.parentId = this.id
    mo.setValue();
    this.mi = mi
    this.mo = mo

    this.setValue= function(){
      mi.forEach(mi => mi.setValue());
      mo.setValue();
    }

    this.removeInputMapping = function(map = Mapping){
      let index =this.mi.findIndex(m => m.id == map.id)
      if(index != -1){
        mi.splice(index, 1)
      }
    }
  }

}

export default LossStructure
